import React from 'react';

const BillScan = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between !mt-0">
        <h1 className="text-2xl font-bold text-light-darkGrey font-roboto cursor-default">
          Bill Scan
        </h1>
      </div>
      {/* Add Bill Scan page content here */}
      <p>Bill Scan page content will go here.</p>
    </div>
  );
};

export default BillScan;